<script lang="ts">
    import Text from '../../../Text.svelte';
    import InterestList from '../../InterestList.svelte';
    import { interestListFormatter } from '../../../../utils';
    import { interests as interestList } from '../../../../stores';

    export let row: any;
</script>

<div class="education">
    {#if !((row.lookalikeId !== '' && row.lookalikeId !== null) || (row.targetId !== '' && row.targetId !== null))}
        {#if JSON.parse(row.education).length > 0}
            <Text type="body1">{row.educationCertainty * 100}%</Text>
            <InterestList
            operator={"OR"}
            interestList={interestListFormatter(row.education, $interestList)}
            />
        {/if}
    {/if}
</div>

<style>
    .education {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    }
</style>
